// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3c7C3","buttons":"Footer_buttons__o8c33"};